import React from 'react'

export default function EvaluationInfoCard({nextStaff}) {
  return (
    <div>
      <div className="row">
        <div className="col-10 col-xl-3 col-sm-6">
          <div className="card card-default">
            <div className="card-body">
                <h5 className="card-title">Current Evaluator</h5>
                <p className="card-text text-dark font-weight-bold">
                  {nextStaff?.USER_ROLE_TEXT ? `${nextStaff.FIRST_NAME} ${nextStaff.LAST_NAME} (${nextStaff.USER_ROLE_TEXT})` : ''}
                </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
